import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Radar, X, ArrowRight } from "lucide-react";
import { API } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

const client = axios.create({ baseURL: API, timeout: 20000, withCredentials: true });

export const ProbeAlertBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const isArchitect = !!user?.is_architect;

  useEffect(() => {
    if (!isArchitect) return undefined;
    const load = () => client.get("/architect/security/alerts").then(({ data }) => setAlerts(data.alerts)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [isArchitect]);

  if (!isArchitect || alerts.length === 0) return null;

  const dismiss = async () => {
    const ips = alerts.map((a) => a.ip);
    setAlerts([]);
    await Promise.all(ips.map((ip) => client.post("/architect/security/alerts/dismiss", { ip }).catch(() => {})));
  };

  const top = alerts.slice(0, 3);
  return (
    <div className="border-b border-red-500/40 bg-red-950/40 px-4 sm:px-8 py-2.5 flex flex-wrap items-center gap-3 text-xs" data-testid="probe-alert-banner">
      <Radar className="h-3.5 w-3.5 text-red-300 shrink-0" />
      <span className="text-red-100" data-testid="probe-alert-text">
        {alerts.length} {alerts.length === 1 ? "address" : "addresses"} hit 3+ blocked attempts today:{" "}
        {top.map((a, i) => (
          <span key={a.ip}>
            <span className="font-mono text-red-200">{a.ip}</span> ({a.count}){i < top.length - 1 ? ", " : ""}
          </span>
        ))}
        {alerts.length > 3 ? ` and ${alerts.length - 3} more` : ""}
      </span>
      <button onClick={() => navigate("/settings#probe-dashboard")} data-testid="probe-alert-view"
        className="ml-auto inline-flex items-center gap-1 px-3 py-1 border border-red-400/60 text-red-200 hover:bg-red-500 hover:text-zinc-950 transition-colors">
        Review <ArrowRight className="h-3 w-3" />
      </button>
      <button onClick={dismiss} data-testid="probe-alert-dismiss" aria-label="Dismiss for today"
        className="p-1 text-red-300 hover:text-red-100 transition-colors">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
